

import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';

export default function ChartsOverviewDemo(props) {

  const adder=(data, product)=>{
    var sorter = data.filter(bug=>bug.product===product)
    var total=0
    for (var i in sorter){
      total+=parseFloat(sorter[i].amount)
    }
    
    return total
    
      }

      
  return (
    <BarChart
      series={[
        { data: [adder(props.sales, "Maize"), adder(props.sales, "Soya Beans"), adder(props.sales, "Onio"), adder(props.sales, "Pepper"), adder(props.sales, "Tomatoes")] }
      ]}
      height={200}
      xAxis={[{ data: ["Maize",  "Soya Beans", "Onion", "Pepper",  "Tomatoes"], scaleType: 'band' }]}
      margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
    />
  );
}
